export function emailPreviewDocument(html, loadImages = false) {
  const document = new DOMParser().parseFromString(html, "text/html");
  // Previewing a message must not run code, navigate, or record engagement.
  document
    .querySelectorAll(
      "script, iframe, object, embed, link, base, meta[http-equiv]"
    )
    .forEach((node) => node.remove());
  document.querySelectorAll("a, area").forEach((node) => {
    node.removeAttribute("href");
    node.removeAttribute("target");
  });
  const policy = document.createElement("meta");
  policy.httpEquiv = "Content-Security-Policy";
  policy.content = `default-src 'none'; style-src 'unsafe-inline'; img-src data:${
    loadImages ? " https: http:" : ""
  }; base-uri 'none'; form-action 'none'`;
  document.head.prepend(policy);
  return `<!DOCTYPE html>${document.documentElement.outerHTML}`;
}
